import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';

import { orderObjectSelector } from '@arreeba/ristoranti-frontend-lib/lib/selectors/order';

import { COMMON_LOCALIZED } from '../../lib/localized';
import { connect } from '../../util';
import Url from '../../lib/url';
import ButtonsContainer from '../../components/buttonsContainer';
import BackButton from '../../components/back-button';
import Button from '../../components/button';
import OrderRecap from '../../components/order-recap';
import { urlSelector } from '../../selectors/urlSelectors';
import { orderLocationAddressSelector, orderOvercomeThreshold } from '../../selectors/orderSelectors';
import {
  Cart,
} from '../../components/cart/';

class OrderCart extends React.Component {
  constructor(props) {
    super(props);
    this.onRemoveFromCart = this.onRemoveFromCart.bind(this);
    this.goToCheckout = this.goToCheckout.bind(this);
  }

  onRemoveFromCart(item) {
    this.props.actions.order.removeFromCart(item);
  }

  goToCheckout() {
    if (!this.props.orderOvercomeThreshold) return;
    browserHistory.push(Url.orderUserVoucher({ ...this.props.url }));
  }

  render() {
    const cartObject = this.props.cartObject;
    return (
      <main>
        <h4 className="viewTitle">IL TUO ORDINE</h4>
        <div className="cartContainer">
          <Cart
            items={cartObject.cart}
            extraCosts={cartObject.extraCosts}
            onRemove={this.onRemoveFromCart}
            subtotal={cartObject.subtotal}
            total={cartObject.total}
          />
        </div>
        <footer className="cartFooter">
          <OrderRecap
            date={this.props.url.orderDate}
            location={this.props.orderAddress}
          />
        </footer>
        <ButtonsContainer>
          <BackButton />
          <Button
            type="next"
            text="CONTINUA"
            disabled={!this.props.orderOvercomeThreshold}
            onClick={this.goToCheckout}
          />
        </ButtonsContainer>
      </main>
    );
  }
}

OrderCart.propTypes = {
  orderOvercomeThreshold: PropTypes.bool.isRequired,
};

const mapStateToProps = (state, props) => ({
  ...state,
  url: urlSelector(state, props),
  orderAddress: orderLocationAddressSelector(state, props).address,
  cartObject: orderObjectSelector(COMMON_LOCALIZED)(state, props),
  orderOvercomeThreshold: orderOvercomeThreshold(state, props),
});

export default connect(OrderCart, { mapStateToProps });



// WEBPACK FOOTER //
// ./src/containers/order/order-cart.js